import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../services/firebase";

/**
 * Shown after fast-path onboarding when ensemble size was not collected.
 */
export default function DeferredProfilingBanner() {
  const [user] = useAuthState(auth);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    (async () => {
      const snap = await getDoc(doc(db, "users", user.uid));
      if (cancelled || !snap.exists()) return;
      const d = snap.data();
      if (
        d.onboardingDeferredProfilingPending &&
        !d.onboardingProfile?.typicalPerformerCount
      ) {
        setVisible(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  const dismiss = async () => {
    if (!user) return;
    setVisible(false);
    try {
      await updateDoc(doc(db, "users", user.uid), {
        onboardingDeferredProfilingPending: false,
      });
    } catch {
      // non-blocking
    }
  };

  if (!visible) return null;

  return (
    <div className="mb-6 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <p className="text-sm text-blue-900">
        Quick win: add your typical ensemble size in your account so DrillFlo
        can tailor defaults for you.
      </p>
      <div className="flex items-center gap-3 shrink-0">
        <Link
          to="/my-account"
          className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Complete profile
        </Link>
        <button
          type="button"
          onClick={dismiss}
          className="text-sm text-blue-800 hover:underline"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
